import React, { Fragment, useState, useEffect, useContext } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import { isMobile } from "react-device-detect";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import { confirmQueries } from "../../../resolvers";
import Resultlist from "./result";
import { Loading } from "../../../../components";
import { ShopperContext } from "../contexts";
import { Link } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: isMobile ? theme.spacing(2) : theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: isMobile ? "1em" : "3em",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: (state) =>
      state.page !== "update"
        ? theme.palette.primary.main
        : theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    height: "4em",
  },
}));

export default function Components() {
  const { state, setState } = useContext(ShopperContext);

  const changeState = (value) => {
    setState({ ...state, ...value });
  };

  const classes = useStyles();
  const location = useLocation();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const res = await axios.get("https://geolocation-db.com/json/");
    changeState({
      serino: initialState.serino,
      code: initialState.code,
      ip: res.data.IPv4,
    });
  };
  const [load, setLoad] = useState(true);
  const [initialState, setInitialState] = useState({});
  const [initialError, setInitialError] = useState({});

  const handleChange = (event) => {
    setInitialState({
      ...initialState,
      [event.target.name]: event.target.value,
    });

    setInitialError({
      ...initialError,
      [event.target.name]: event.target.value ? false : true,
    });
  };

  const getValue = async (s) => {
    const x = s.substring(1);
    const b = x.substring(0, x.indexOf("&"));
    const a = x.substring(x.indexOf("&") + 1);
    const serino = b.substring(b.indexOf("=") + 1);
    const code = a.substring(a.indexOf("=") + 1);
    const res = await axios.get("https://geolocation-db.com/json/");
    changeState({
      serino,
      code,
      ip: res.data.IPv4,
    });
  };

  const { loading, data, refetch } = useQuery(confirmQueries.MANUEL_CONFIRM, {
    fetchPolicy: "cache-and-network",
    onCompleted(data) {
      setLoad(false);
    },
    variables: {
      data: {
        ...state,
      },
    },
    onError(err) {
      console.log(err);
    },
  });

  useEffect(() => {
    if (location.search) getValue(location.search);
  }, [useLocation().search]);

  useEffect(() => {
    setTimeout(function () {
      setLoad(false);
    }, 3000);
  }, []);

  if (loading || load) return <Loading />;
  return (
    <Fragment>
      {!state.serino && !state.code ? (
        <Container maxWidth="sm">
          <CssBaseline />
          <Paper className={classes.paper} elevation={2}>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Typography component="h1" variant="h5">
                {"Anzer Balı Sorgula"}
              </Typography>
              <form className={classes.form} noValidate onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      onChange={handleChange}
                      value={initialState.serino ? initialState.serino : ""}
                      error={initialError.serino}
                      name="serino"
                      variant="outlined"
                      fullWidth
                      id="serino"
                      label="Seri No"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      onChange={handleChange}
                      value={initialState.code ? initialState.code : ""}
                      error={initialError.code}
                      name="code"
                      variant="outlined"
                      fullWidth
                      id="code"
                      label="Kod"
                    />
                  </Grid>
                </Grid>
                <Grid item style={{ marginTop: 16 }}></Grid>
                <Grid
                  item
                  container
                  direction="row"
                  justify="flex-end"
                  alignItems="center"
                >
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                  >
                    Sorgula
                  </Button>
                </Grid>
              </form>
            </Grid>
          </Paper>
        </Container>
      ) : (
        <Resultlist data={data} />
      )}    
    </Fragment>
  );
}
